import { render, staticRenderFns } from "./DataTableSetting.vue?vue&type=template&id=1731f30e"
import script from "./DataTableSetting.vue?vue&type=script&lang=js"
export * from "./DataTableSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports